import type { ViewStyle } from 'react-native'

export const LESSON_NAV_SHADOW_L1 =
  '0px 2px 4px 0px rgba(0,0,0,0.12), 0px 0px 2px 0px rgba(0,0,0,0.08)'

export function lessonNavForeground(enabled: boolean, elevated: boolean): string {
  if (!enabled) return '#C9C5C3'
  if (elevated) return '#FFFFFF'
  return '#0D0D0D'
}

export function lessonNavCompactSurface(enabled: boolean, elevated: boolean): ViewStyle {
  return {
    width: 40,
    height: 40,
    borderRadius: 30,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
    backgroundColor: enabled && elevated ? '#0D0D0D' : '#FFFFFF',
    borderWidth: 1,
    borderColor: enabled && elevated ? '#0D0D0D' : '#C9C5C3',
    opacity: enabled ? 1 : 0.4,
    boxShadow: LESSON_NAV_SHADOW_L1,
  }
}

export function lessonNavToolbarPillSurface(
  enabled: boolean,
  elevated: boolean,
  side: 'previous' | 'next',
): ViewStyle {
  const horizontal =
    side === 'previous'
      ? { paddingLeft: 12, paddingRight: 16 }
      : { paddingLeft: 16, paddingRight: 12 }
  return {
    flexDirection: 'row',
    alignItems: 'center',
    height: 40,
    borderRadius: 30,
    gap: 4,
    ...horizontal,
    backgroundColor: enabled && elevated ? '#0D0D0D' : '#FFFFFF',
    borderWidth: 1,
    borderColor: enabled && elevated ? '#0D0D0D' : '#C9C5C3',
    opacity: enabled ? 1 : 0.4,
    boxShadow: LESSON_NAV_SHADOW_L1,
  }
}

export function lessonNavBottomSurface(
  enabled: boolean,
  elevated: boolean,
  iconOnly: boolean,
  isNext: boolean,
): ViewStyle {
  const base: ViewStyle = {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: iconOnly ? 'center' : isNext ? 'flex-end' : 'flex-start',
    height: 40,
    borderRadius: 30,
    backgroundColor: enabled && elevated ? '#0D0D0D' : '#FFFFFF',
    borderWidth: 1,
    borderColor: enabled && elevated ? '#0D0D0D' : '#C9C5C3',
    opacity: enabled ? 1 : 0.4,
    boxShadow: LESSON_NAV_SHADOW_L1,
  }
  if (iconOnly) {
    return {
      ...base,
      width: 40,
      padding: 10,
    }
  }
  return {
    ...base,
    paddingLeft: 24,
    paddingRight: 16,
  }
}
